import { Cohort } from 'root-constants'
import { useZustandStore } from 'zustandGlobalStore'

const CUSTOMER_DATA_EVENT = 'CustomerData'
const UUID_QUERY_PARAM = 'uuid'

export const sendRetenoCustomerData = (email?: string): void => {
  if (typeof window === 'undefined') {
    return
  }

  const cohort =
    useZustandStore.getState().lead?.cohort ||
    useZustandStore.getState().initialCohort

  if (cohort !== Cohort.INTL_2) {
    return
  }

  const uuidFromUrl = new URLSearchParams(window.location.search).get(
    UUID_QUERY_PARAM,
  )
  const externalCustomerId =
    uuidFromUrl || useZustandStore.getState().lead?.id || ''

  if (!externalCustomerId) {
    return
  }

  if (typeof window.eS === 'function') {
    window.eS('sendEvent', CUSTOMER_DATA_EVENT, {
      [CUSTOMER_DATA_EVENT]: {
        externalCustomerId,
        ...(email ? { user_email: email } : {}),
      },
    })
  }

  if (typeof window.es === 'function') {
    window.es('sendEvent', CUSTOMER_DATA_EVENT, '', {
      externalCustomerId,
      ...(email ? { email } : {}),
    })
  }
}
